import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchGetAgendas = async ({ studyId }) => {
  // 쿼리 파라미터가 추가된 URL로 API를 호출합니다.
  const params = new URLSearchParams();
  if (studyId) {
    params.append("studyId", studyId); // 'q'는 일반적으로 검색 쿼리를 나타내는 파라미터입니다.
  }

  return await api.get(`/agenda?${params.toString()}`);
};

export const useGetAgendasQuery = (studyId) => {
  return useQuery({
    queryKey: ["agendas", studyId],
    enabled: !!studyId,
    queryFn: () => fetchGetAgendas(studyId),
    select: (data) => {
      return data.data.data;
    },
  });
};
